
import SchedulerOverlay from '../overlays/SchedulerOverlay.vue';
import Scheduler from '../Scheduler.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import AddionalFilterCard from '../scheduler/AdditionalFilterCard.vue';
import Message from '@/data/notificationsMessages';
import managerViewFiltersTemplate from "@/data/filtersTemplates/scheduler/managerViewFIltersTemplate";
import ManagerAdvancedFilter from '../scheduler/filters/ManagerAdvancedFilter.vue';
import { defaultErrorNotificationMessage } from "@/data/errorMessages";
import { Company, Manager, Manager_Bool_Exp, Manager_Order_By, Order_By, Project_Bool_Exp, User } from "@/generated/graphql";
import { NOTIFICATION } from "@/entities/Events";
import ManagerRadioButtonOptions from "@/entities/scheduler/ManagerRadioButtonOptions";
import Roles from "@/entities/Roles";
import RangeChangedPayload from "@/entities/scheduler/RangeChangedPayload";
import ManagerViewProjectItemFields from "@/entities/scheduler/ManagerViewProjectItem";
import CustomTimelineGroup from "@/entities/scheduler/CustomTimelineGroup";
import TimelineOptionsWithTemplates from "@/entities/scheduler/TimelineOptionsWithTemplates";
import ManagerViewFiltersToWatch from "@/entities/scheduler/additionalFiltersInterfaces/ManagerVIewFIltersToWatch";
import { getEmptyFiltersResultMessage, getEmptyListMessage, getEmptyScheduleListMessage } from "@/helpers/lists/emptyListMessages";

import getFullName from "@/helpers/getFullName";
import getFetchMoreStartDates from "@/helpers/scheduler/getFetchMoreStartDates";
import SelectPayload from "@/entities/scheduler/SelectPayload";
import NewlyCreatedSchedulerItem from "@/entities/scheduler/NewlyCreatedSchedulerItem";
import RouteNames from "@/entities/RouteNames";
import RouteParams from "@/entities/RouteParams";
import ProjectDataForModal from "@/entities/modals/ProjectDataForModal";
import GET_MANAGER_PROJECTS from "@/apollo/scheduler/GetManagerProjects.gql"
import moment from "moment";
import { cloneDeep } from "lodash-es";
import SchedulerFilters from '@/entities/scheduler/additionalFiltersInterfaces/SchedulerFilters';
import schedulerViewFiltersTamplate from '@/data/filtersTemplates/scheduler/schedulerViewFiltersTamplate';


@Component({
    components: {
        SchedulerOverlay,
        Scheduler,
        AddionalFilterCard,
        ManagerAdvancedFilter
    },
    apollo: {
        managerProjects: {
            query: GET_MANAGER_PROJECTS,
            update: data => data.manager,
            skip: true,
        }
    }
})
export default class ManagerScheduler extends Vue {
    @Prop({ type: Boolean, default: true }) readonly hasData!: boolean;;
    @Prop({ type: Boolean, default: true }) readonly isLoading!: boolean;
    @Prop({ type: Array, default: () => [] }) readonly managers!: any[];

    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: String, required: true }) readonly companyId!: string;
    @Prop({ type: Date, default: undefined }) readonly axisStart?: Date;
    @Prop({ type: Date, default: undefined }) readonly axisEnd?: Date;
    @Prop({ type: Array, default: () => [] }) readonly selectedManagersIds!: string[];
    @Prop({ type: Boolean, default: false }) readonly showAdditionalFilters!: boolean;
    @Prop({ type: Boolean, default: false }) readonly shouldClearFilters!: boolean;


    managerProjects: Manager[] = [];
    queryStartTime: Date = moment().startOf('month').subtract(2, 'w').toDate();
    queryEndTime: Date = moment().endOf('month').toDate();
    numberOfAppliedFilters = 0;

    modalShown = false;
    message: string = 'You haven\'t invited any managers yet';

    projectInfoForModal?: ProjectDataForModal | null = null;
    newlyCreatedItemId?: string = undefined;
    additionalFilters: SchedulerFilters = cloneDeep(schedulerViewFiltersTamplate);
    passedStartDate: Date = moment().startOf('month').toDate();
    passedEndDate: Date = moment().endOf('month').toDate();
    isEdittingLocked: boolean = true;


    get type() {
        return 'Manager';
    }

    projectColors: string[] = [
        "#1A7BEE",
        "#8B3EFF",
        "#FF8E3C",
        "#01B549",
        "#DA1B8F"
    ]

    getRandColor() {
        return this.projectColors[Math.floor(Math.random() * this.projectColors.length)];
    }
    created() {
        this.$apollo.queries.managerProjects.setVariables({
            where: this.where,
            projectsWhere: this.projectsWhere,
        });
        this.$apollo.queries.managerProjects.skip = false;
    }

    @Watch("propToWatch")
    refetchOnDataFiltersChange(oldVal: string[], newVal: string[]) {
        if (oldVal !== newVal) {
            this.$apollo.queries.managerProjects.refetch({
                where: this.where,
                projectsWhere: this.projectsWhere,
                orderBy: this.orderBy,
            });
            if (this.managerProjects.length <= 0) {
                this.message = getEmptyFiltersResultMessage('information');
            }
        }
    }

    @Watch("numberOfAppliedFilters", { immediate: true })
    appliedFiltersChanged() {
        this.$emit("appliedFiltersChanged", this.numberOfAppliedFilters);
    }

    get linkToProject(): RouteParams<{ id: string }> {
        return {
            name: RouteNames.PROJECT_ACTIVITY,
            params: { id: this.projectInfoForModal?.id || "" },
        }
    }

    get showLinkToProject(): boolean {
        return Boolean(!this.projectInfoForModal?.isNew);
    }



    nextValue() {
        this.managerProjects = [];
        this.message = 'No search results found for query';
    }

    get propToWatch(): string {
        return JSON.stringify([
            this.selectedManagersIds,
            this.additionalFilters,
        ]);
    }

    get customPlaceholderMessage(): string {
        if (this.numberOfAppliedFilters && !this.managersForGroups.length) {
            return getEmptyFiltersResultMessage("data");
        }
        return getEmptyScheduleListMessage("managers");
    }

    get loading(): boolean {
        return this.$apollo.queries.managerProjects.loading && !this.managerProjects.length;
    }

    get isManager(): boolean {
        return this.currentUser.role === Roles.MANAGER;
    }

    get isAdmin(): boolean {
        return this.currentUser.role == Roles.ADMIN;
    }

    get startTime() {
        return this.queryStartTime;
    }

    get projectIds(): string[] {
        return this.managerProjects
            .map(manager => {
                return manager.projects
                    .map(project => project.id);
            })
            .flat();
    }

    get projectsWhere(): Project_Bool_Exp {
        return {
            _or: [
                {
                    start_date: {
                        _lte: this.queryEndTime,
                        _gte: this.queryStartTime,
                    }
                },
                {
                    end_date: {
                        _lte: this.queryEndTime,
                        _gte: this.queryStartTime,
                    }
                },
                {
                    _and: [
                        {
                            start_date: {
                                _lte: this.queryStartTime,
                            }
                        },
                        {
                            end_date: {
                                _gte: this.queryEndTime
                            }
                        }
                    ]
                }
            ]
        }
    }

    get orderBy(): Manager_Order_By {
        return
        { projects_aggregate: { count: Order_By.Asc } };
    }

    get where(): Manager_Bool_Exp {
        const filterConditions: any = [];
        const {
            countries,
            states,
            cities
        } = this.additionalFilters;

        if (this.selectedManagersIds.length) {
            filterConditions.push({
                id: {
                    _in: this.selectedManagersIds,
                }
            })
        }

        if (countries.length) {
            filterConditions.push({
                user: {
                    profile: {
                        country: { _in: countries },
                    },
                },
            });
        }

        if (states.length) {
            filterConditions.push({
                user: {
                    profile: {
                        state: { _in: states },
                    },
                },
            });
        }

        if (cities.length) {
            filterConditions.push({
                user: {
                    profile: {
                        city: { _in: cities },
                    },
                },
            });
        }

        return { _and: filterConditions };
    }

    get managersForGroups(): Manager[] {
        if (!this.managerProjects) {
            return [];
        }
        return this.managerProjects;
    }

    get managerGroups(): CustomTimelineGroup[] {
        if (this.isManager) {
            const currentManagerGroup = this.managersForGroups.filter(manager => {
                return this.currentUser.manager?.id === manager.id;
            });
            return [{
                id: currentManagerGroup[0]?.id,
            }];
        }
        return this.managersForGroups.map(manager => {
            const managerUser = manager.user;
            return {
                id: manager!.id,
                name: getFullName(managerUser.given_name!, managerUser.family_name!),
                avatar: managerUser.avatar || "",
            }
        }
        );
    }

    get projectItems(): ManagerViewProjectItemFields[] | any {
        if (!this.managerProjects) {
            return [];
        }

        return this.managerProjects
            .map(manager => {
                const groupId = manager.id;
                return manager.projects
                    .map(project => {
                        return {
                            id: project?.id || "",
                            group: groupId,
                            content: project?.name! || "",
                            start: project?.start_date || "",
                            end: project?.end_date || "",
                            project: project as ProjectDataForModal || {},
                        }
                    })
                    .filter(item => Boolean(item));
            })
            .flat();
    }
    //get manager with projects attached in map
    get managerWithProjects(): any[] {
        if (!this.managerProjects) {
            return [];
        }
        return this.managerProjects.map(manager => {
            return {
                id: manager!.id,
                title: manager.user?.profile?.job_title,
                name: getFullName(manager.user.given_name!, manager.user.family_name!),
                avatar: manager.user.avatar || "",
                color: this.getRandColor(),
                contractors: manager.contractors.map(contractor => {
                    return {
                        id: manager!.id,
                        name: getFullName(contractor.contractor.user.given_name!, contractor.contractor.user.family_name!),
                        avatar: contractor.contractor.user.avatar || "",
                        color: this.getRandColor(),
                    }
                }),
                projects: manager.projects.map(project => {
                    return {
                        id: project?.id || "",
                        content: project?.name! || "",
                        start: project?.start_date || "",
                        end: project?.end_date || "",
                        color: this.getRandColor(),
                        completed: project?.completed || false,
                        project: project as ProjectDataForModal || {},
                    }
                })
            }
        }).flat();
    }


    get options(): TimelineOptionsWithTemplates {
        return {
            start: this.passedStartDate,
            end: this.passedEndDate,
            autoResize: true,
            onAdd: function (item, callback) {
                item.className = "newItem";
                callback(item);
            },
        }
    }

    getRandomeInt(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    async rangeChanged(e: RangeChangedPayload): Promise<void> {
        this.$emit('rangechanged', e);
        const fetchMoreDates = getFetchMoreStartDates(this.queryStartTime, this.queryEndTime, e);
        if (!fetchMoreDates) {
            return;
        }
        const { queryStartTime, queryEndTime, whereDatesConditions } = fetchMoreDates;
        this.queryStartTime = queryStartTime;
        this.queryEndTime = queryEndTime;

        try {
            await this.$apollo.queries.managerProjects.fetchMore({
                variables: {
                    where: this.where,
                    projectsWhere: { _or: whereDatesConditions },
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    const updatedManagers: Manager[] = fetchMoreResult.manager;
                    const res = {
                        manager: previousResult.manager.map((manager: Manager) => {
                            const correspondingManager: Manager | undefined = updatedManagers.find(updatedManager => {
                                return updatedManager.id === manager.id;
                            });
                            if (correspondingManager) {
                                const newProjects = correspondingManager.projects.filter(project => {
                                    return !this.projectIds.includes(project.id);
                                });
                                return {
                                    ...manager,
                                    projects: [...manager.projects, ...newProjects],
                                    __typename: "manager"
                                }
                            } else {
                                return manager;
                            }
                        })
                    }
                    return res;
                },
            })
        } catch (e) {
            this.$eventBus.emit(
                NOTIFICATION,
                Message.errorMessage(defaultErrorNotificationMessage),
            );
        }
    }


    handleIconClose(): void {
        this.$emit('close')
    }
    handleAppliedFiltersNumberChanged(num: number) {
        this.numberOfAppliedFilters = num;
    }

    handleFiltersChanged(filters: SchedulerFilters) {
        this.additionalFilters.countries = filters.countries;
        this.additionalFilters.states = filters.states;
        this.additionalFilters.cities = filters.cities;
    }

    handleSelect(payload: SelectPayload): void {
        const selectedItemId: string = payload?.items?.[0];
        if (!selectedItemId) {
            return;
        }
        const selectedItem = this.projectItems.filter(project => project.id === selectedItemId)[0];
        if (!selectedItem) {
            this.newlyCreatedItemId = selectedItemId;
            return;
        }
        this.projectInfoForModal = selectedItem.project;
        this.modalShown = true;
    }

    handleCloseModal(): void {
        if (this.modalShown == false) {
            return;
        }
        this.clearSelectedItems();
        if (this.newlyCreatedItemId) {
            this.clearNewlyCreatedItemId();
            this.setCurrentlyFetchedItems();
        }
        this.closeModal();
    }

    async handleCollectionUpdated(): Promise<void> {
        this.clearNewlyCreatedItemId();
        this.clearSelectedItems();
        await this.refetchCollection();
        this.closeModal();
    }

    async refetchCollection(): Promise<void> {
        await this.$apollo.queries.managerProjects.refetch({
            where: this.where,
            projectsWhere: this.projectsWhere,
            orderBy: this.orderBy,
        });
    }

    clearSelectedItems(): void {
        (this.$refs.timeline as any).setSelection([]);
    }

    clearNewlyCreatedItemId(): void {
        this.newlyCreatedItemId = undefined;
    }

    closeModal(): void {
        this.projectInfoForModal = undefined;
        this.modalShown = false;
        const timeline = this.$refs.timeline as any;
        timeline.setSelection([]);
        this.isEdittingLocked = true;
    }

    setCurrentlyFetchedItems(): void {
        (this.$refs.timeline as any).setItems(this.projectItems);
    }

    handleCreateBtnClicked(project: NewlyCreatedSchedulerItem) {
        this.projectInfoForModal = {
            company_id: this.company.id,
            manager_id: project.group,
            start_date: project.start,
            end_date: "",
            name: undefined,
            min_budget: null,
            max_budget: null,
            isNew: true,
        };
        this.modalShown = true;
    }

    handleEditClick(): void {
        this.isEdittingLocked = !this.isEdittingLocked;
    }

    handleTimeRangeChanged(rangeStart: Date): void {
        this.passedStartDate = rangeStart
    }

    handleTimeRangeChangedEnd(rangeEnd: Date): void {
        this.passedEndDate = rangeEnd
    }

}
